import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const Callout = makeShortcode("Callout");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Group summary='Client session caching' mdxType="Group">
      <Item title="clientSessionCachingEnabled" subtitle="boolean" label="Default: false" mdxType="Item">
        <Callout variant="danger" emoji="❗" mdxType="Callout">
          <p>{`Before enabling the flag to `}<inlineCode parentName="p">{`true`}</inlineCode>{` it's recommended to reach out to Primer support for additional verification since there are edge cases where it's not advised.`}</p>
        </Callout>
        <p>{`Indicates whether client session caching is enabled.`}</p>
        <p>{`When set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, responses from the server will be cached on the client side, allowing for faster subsequent
access to the same data within the cache duration. When set to `}<inlineCode parentName="p">{`false`}</inlineCode>{`, every request to the server will be
processed without utilizing any client-side cache, ensuring that the client always receives the most up-to-date data.`}</p>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      